<template>
  <div class="tu-filter-search">
    <md-icon class="tu-filter-search__ico">search</md-icon>
    <input
      :value="value"
      type="search"
      :placeholder="placeholder"
      :aria-label="label || placeholder"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
/** The search segment of a TransitionU style filter bar (.tu-toolbar). Draws no border: the bar does. */
export default {
  name: 'TuFilterSearch',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'Search' },
    label: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.tu-filter-search {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  min-height: 56px;
  padding: 0 18px;
}
.tu-filter-search__ico {
  flex: none;
  margin: 0;
  font-size: 20px;
  color: var(--tu-ink-mute, rgba(24, 24, 24, 0.55));
}
.tu-filter-search input {
  width: 100%;
  min-width: 0;
  height: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--tu-ink, #181818);
  font: inherit;
  font-size: 15px;
}
.tu-filter-search input::placeholder {
  color: var(--tu-ink-mute, rgba(24, 24, 24, 0.55));
  opacity: 1;
}
.tu-filter-search input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
</style>
